import { describeChecked } from './lastChecked';

/**
 * One verdict for the whole site, from the same per-retailer timestamps the
 * /status table shows, so the top-bar dot and the page can never disagree.
 *
 *   ok    every retailer's oldest check is within twice its cadence
 *   warn  at least one retailer is running late
 *   down  every retailer is late (the pollers have stopped), or no status
 */
export const STATUS_LEVELS = {
    ok: { label: 'All retailers checking normally', color: '#21b6b7' },
    warn: { label: 'A retailer check is running late', color: '#f59e0b' },
    down: { label: 'Retailer checks are stalled', color: '#ef4444' }
};

export const summarizeStatus = (retailers, { now = Date.now() } = {}) => {
    const list = Array.isArray(retailers) ? retailers : [];
    if (list.length === 0) {
        return { level: 'down', ...STATUS_LEVELS.down, tracked: 0 };
    }
    const late = list.filter((r) => describeChecked(r.oldestCheck, r.pollSeconds, { now }).stale).length;
    const level = late === 0 ? 'ok' : late === list.length ? 'down' : 'warn';
    const tracked = list.reduce((sum, r) => sum + (r.tracked || 0), 0);
    return { level, ...STATUS_LEVELS[level], tracked };
};
